import React, { useState } from "react";
import Header from "../../../layouts/Header";
import Sidebar from "../../../layouts/Sidebar";

const AddBranch = () => {
  const [menu, setMenu] = useState(false);
  const [IsCompanyFreeze, setIsCompanyFreeze] = useState(false);
  const [IsPersonFreeze, setIsPersonFreeze] = useState(false);

  const [formData, setFormData] = useState({
    CompanyCode: "",
    CompanyName: "",
    CompanyDetails: "",
    CompanyAddress1: "",
    CompanyAddress2: "",
    CompanyAddress3: "",
    CompanyCountry: "",
    CompanyState: "",
    CompanyCity: "",
    CompanyFreeze: "",
    PinCode: "",
    ContactPersonFirstName: "",
    ContactPersonLastName: "",
    ContactPersonDepartment: "",
    ContactPersonPhoneNo: "",
    ContactPersonEmail: "",
    CompanyContactPersonFreeze: "",
  });

  const [validation, setValidation] = useState({
    CompanyCode: { isValid: true, message: "" },
    CompanyName: { isValid: true, message: "" },
    CompanyDetails: { isValid: true, message: "" },
    CompanyAddress1: { isValid: true, message: "" },
    CompanyCountry: { isValid: true, message: "" },
    CompanyState: { isValid: true, message: "" },
    CompanyCity: { isValid: true, message: "" },
    PinCode: { isValid: true, message: "" },
    ContactPersonFirstName: { isValid: true, message: "" },
    ContactPersonLastName: { isValid: true, message: "" },
    ContactPersonDepartment: { isValid: true, message: "" },
    ContactPersonPhoneNo: { isValid: true, message: "" },
    ContactPersonEmail: { isValid: true, message: "" },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleIsPersonFreeze = () => {
    setIsPersonFreeze(!IsPersonFreeze);
  };

  const handleIsCompanyFreeze = () => {
    setIsCompanyFreeze(!IsCompanyFreeze);
  };

  const handleSubmitted = (e) => {
    e.preventDefault();

    let isFormValid = true;
    Object.keys(formData).forEach((fieldName) => {
      if (formData[fieldName] === "") {
        isFormValid = false;
        setValidation((prevValidation) => ({
          ...prevValidation,
          [fieldName]: { isValid: false, message: "Field cannot be empty" },
        }));
      }
    });
    let isBillingValid = true;

    if (!isFormValid || !isBillingValid) {
      return;
    }

    console.log(formData);
    console.log(validation);
  };

  const handleInputChange = (fieldName, value) => {
    let isValid = true;
    let message = "";

    const nameRegex = /^[a-zA-Z\s]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (value.trim() === "") {
      isValid = false;
      message = "Field cannot be empty";
    }

    if (fieldName === "ContactPersonEmail" && !emailRegex.test(value)) {
      isValid = false;
      message = "Invalid email id";
    }

    setFormData({
      ...formData,
      [fieldName]: value.trim(),
    });

    setValidation({
      ...validation,
      [fieldName]: { isValid, message },
    });
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={(value) => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="p-8">
            <div className="pb-6">
              <h1 className="text-2xl text-black">Create Branch</h1>
              <span className="text-red-500">User Side</span>
            </div>
            <form className="w-full">
              <div className="flex flex-wrap -mx-3">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyCode"
                  >
                    Company Code <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.CompanyCode.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Company Code"
                    value={formData.CompanyCode}
                    onChange={(e) => {
                      handleInputChange("CompanyCode", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyName"
                  >
                    Company Name<span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.CompanyName.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Company Name"
                    value={formData.CompanyName}
                    onChange={(e) => {
                      handleInputChange("CompanyName", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyDetails"
                  >
                    Company Details<span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.CompanyDetails.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Company Details"
                    value={formData.CompanyDetails}
                    onChange={(e) => {
                      handleInputChange("CompanyDetails", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyAddress1"
                  >
                    Company Address 1<span className="text-red-400"> *</span>
                  </label>
                  <textarea
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.CompanyAddress1.isValid
                        ? "border-red-400"
                        : ""
                    }`}
                    name="body"
                    placeholder="Company Address 1"
                    value={formData.CompanyAddress1}
                    onChange={(e) => {
                      handleInputChange("CompanyAddress1", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyAddress2"
                  >
                    Company Address 2
                  </label>
                  <textarea
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
                    name="body"
                    placeholder="Company Address 2"
                    value={formData.CompanyAddress2}
                    onChange={(e) => {
                      handleInputChange("CompanyAddress2", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyAddress3"
                  >
                    Company Address 3
                  </label>
                  <textarea
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
                    name="body"
                    placeholder="Company Address 3"
                    value={formData.CompanyAddress3}
                    onChange={(e) => {
                      handleInputChange("CompanyAddress3", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyCountry"
                  >
                    Company Country<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.CompanyCountry.isValid
                          ? "border-red-400"
                          : ""
                      }`}
                      value={formData.CompanyCountry}
                      onChange={(e) => {
                        handleInputChange("CompanyCountry", e.target.value);
                      }}
                    >
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyState"
                  >
                    Company State<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.CompanyState.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.CompanyState}
                      onChange={(e) => {
                        handleInputChange("CompanyState", e.target.value);
                      }}
                    >
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyCity"
                  >
                    Company City<span className="text-red-400"> *</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                        !validation.CompanyCity.isValid ? "border-red-400" : ""
                      }`}
                      value={formData.CompanyCity}
                      onChange={(e) => {
                        handleInputChange("CompanyCity", e.target.value);
                      }}
                    >
                      <option>New Mexico</option>
                      <option>Missouri</option>
                      <option>Texas</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="PinCode"
                  >
                    Zip Code <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.PinCode.isValid ? "border-red-400" : ""
                    }`}
                    type="text"
                    placeholder="Zip Code"
                    value={formData.PinCode}
                    onChange={(e) => {
                      handleInputChange("PinCode", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3 mb-2">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyFreeze"
                    onClick={handleIsCompanyFreeze}
                  >
                    <input
                      type="checkbox"
                      checked={IsCompanyFreeze}
                      onChange={(e) => setIsCompanyFreeze(e.target.checked)}
                    />
                    <span className="pl-1">Freeze Company</span>
                  </label>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <hr className="w-full" />
                  <h1 className="text-lg text-black py-4">
                    Add Branch Contact
                  </h1>
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ContactPersonFirstName"
                  >
                    First Name <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.ContactPersonFirstName.isValid
                        ? "border-red-400"
                        : ""
                    }`}
                    type="text"
                    placeholder="Person First Name"
                    value={formData.ContactPersonFirstName}
                    onChange={(e) => {
                      handleInputChange(
                        "ContactPersonFirstName",
                        e.target.value
                      );
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ContactPersonLastName"
                  >
                    Last Name <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.ContactPersonLastName.isValid
                        ? "border-red-400"
                        : ""
                    }`}
                    type="text"
                    placeholder="Person Last Name"
                    value={formData.ContactPersonLastName}
                    onChange={(e) => {
                      handleInputChange(
                        "ContactPersonLastName",
                        e.target.value
                      );
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ContactPersonDepartment"
                  >
                    Department <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.ContactPersonDepartment.isValid
                        ? "border-red-400"
                        : ""
                    }`}
                    type="text"
                    placeholder="Department"
                    value={formData.ContactPersonDepartment}
                    onChange={(e) => {
                      handleInputChange(
                        "ContactPersonDepartment",
                        e.target.value
                      );
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ContactPersonPhoneNo"
                  >
                    Phone No <span className="text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.ContactPersonPhoneNo.isValid
                        ? "border-red-400"
                        : ""
                    }`}
                    type="text"
                    placeholder="Phone No"
                    value={formData.ContactPersonPhoneNo}
                    onChange={(e) => {
                      handleInputChange("ContactPersonPhoneNo", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full md:w-1/3 px-3 mb-6">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="ContactPersonEmail"
                  >
                    Email <span className="text-xs text-red-400"> *</span>
                  </label>
                  <input
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
                      !validation.ContactPersonEmail.isValid
                        ? "border-red-400"
                        : ""
                    }`}
                    type="text"
                    placeholder="Email"
                    value={formData.ContactPersonEmail}
                    onChange={(e) => {
                      handleInputChange("ContactPersonEmail", e.target.value);
                    }}
                  />
                </div>
                <div className="w-full px-3 mb-2">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="CompanyContactPersonFreeze"
                    onClick={handleIsPersonFreeze}
                  >
                    <input
                      type="checkbox"
                      checked={IsPersonFreeze}
                      onChange={(e) => setIsPersonFreeze(e.target.checked)}
                    />
                    <span className="pl-1"> Freeze Person</span>
                  </label>
                </div>
              </div>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-6">
                  <button
                    onClick={handleSubmitted}
                    className="bg-gray-100 hover:bg-green-300 text-green-700 font-bold border-solid border-2 hover:border-green-400 border-gray-200 py-2 px-4 rounded inline-flex items-center float-right"
                  >
                    <svg
                      className="fill-current"
                      height="20"
                      viewBox="0 0 512 512"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M465.94,119.76l-73.7-73.7h0A47.68,47.68,0,0,0,358.3,32H96A64,64,0,0,0,32,96V416a64,64,0,0,0,64,64H416a64,64,0,0,0,64-64V153.7A47.68,47.68,0,0,0,465.94,119.76ZM120,112H296a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H120a8,8,0,0,1-8-8V120A8,8,0,0,1,120,112ZM259.75,431.91a80,80,0,1,1,76.16-76.16A80.06,80.06,0,0,1,259.75,431.91Z" />
                      <circle cx="256" cy="352" r="48" />
                    </svg>
                    <span className="pl-2">Create Branch</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddBranch;
